import useSmartField from 'hooks/useSmartField';
import { FV } from './share';
import { Button, message, Modal } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import useModal from 'hooks/useModal';
import StatusButton from 'components/StatusButton';
import { langMap, regionLangMap } from '../share';
import { getLength, useConceptContext, value2editorValue } from '../WhatsAppEditor/ContentEditor';
import { translateTemplate } from 'views/Aide/Scenario/PolicyForm/TranslateTool';

function CopyRegionButton({
  targetRegion,
  onCopy,
}: {
  targetRegion: Aide.WhatsAppRegion;
  onCopy: () => void;
}) {
  const { t } = useTranslate();

  const {
    field: { value, onChange },
  } = useSmartField<FV['regionTemplateMap']>('regionTemplateMap');

  const { getValue } = useConceptContext();

  const { visible, show, hide } = useModal();

  const target = value[targetRegion];

  if (!target) {
    return null;
  }

  const { header, content, translateContent, buttons } = target;

  const targetContent = (getLength(content || []) ? content : translateContent) || [];

  return (
    <>
      <Modal
        title={t('aide.提示')}
        width={380}
        visible={visible}
        onCancel={hide}
        footer={[
          <Button
            onClick={() => {
              onChange(
                Object.keys(value).reduce(
                  (res, key) => {
                    if (key === targetRegion) {
                      return res;
                    }
                    res[key] = {
                      ...res[key],
                      header,
                      content: targetContent,
                      translateContent: [],
                      buttons,
                    };
                    return res;
                  },
                  { ...value },
                ),
              );
              hide();
              onCopy();
            }}
          >
            {t('aide.不需要翻译')}
          </Button>,
          <StatusButton
            type="primary"
            onClick={() => {
              return Object.keys(value)
                .reduce((res, key) => {
                  if (key === targetRegion) {
                    return res;
                  }
                  return res.then((res) => {
                    return (
                      getLength(targetContent)
                        ? translateTemplate(
                            value2editorValue(targetContent),
                            langMap[regionLangMap[key]],
                          )
                        : Promise.resolve([])
                    ).then((translated) => {
                      res[key] = {
                        ...res[key],
                        header,
                        content,
                        translateContent: getValue(translated),
                        buttons,
                      };
                      return res;
                    });
                  });
                }, Promise.resolve({ ...value }))
                .then((next) => {
                  onChange(next);
                  hide();
                  onCopy();
                })
                .catch(() => {
                  message.error(t('marketing.翻译失败，请稍后再试'));
                });
            }}
          >
            {t('aide.需要翻译')}
          </StatusButton>,
        ]}
      >
        {t('aide.复制任务提示')}
      </Modal>
      <Button type="link" icon={<CopyOutlined />} onClick={show}>
        {t('aide.复用内容至其他全部站点')}
      </Button>
    </>
  );
}

export default CopyRegionButton;
